/**
 * Ecoscape readable product configuration links (unpublished-theme prototype).
 * Bin Storage: ?configuration=single-lid-charcoal
 * Outdoor Kitchens: ?configuration=cotton
 * Native Horizon picker remains the source of truth for product/variant state.
 */
(() => {
  'use strict';

  const url = new URL(window.location.href);
  const requested = url.searchParams.get('configuration');
  const handle = url.pathname.split('/').filter(Boolean).pop();
  const known = {
    'bin-storage': /^(single|double|triple|quadruple)-(lid|planter)-(charcoal|woodgrain-charcoal)$/,
    'outdoor-kitchen-sink-unit': /^(cotton|taupe|oak|smoke)$/,
    'outdoor-kitchen-set-of-3-units': /^(cotton|taupe|oak|smoke)$/,
  };
  if (!requested || !known[handle]?.test(requested)) return;

  const slug = (value) =>
    value.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/&/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

  async function selectConfiguration() {
    await customElements.whenDefined('variant-picker');
    const picker = document.querySelector('variant-picker[data-product-handle="' + handle + '"][data-template-product-match="true"]');
    if (!picker) return;

    const choices = handle === 'bin-storage'
      ? { Capacity: requested.split('-')[0], Top: requested.split('-')[1], Finish: requested.split('-').slice(2).join('-') }
      : { Finish: requested };

    const targets = Object.entries(choices).map(([name, value]) => {
      const radios = Array.from(picker.querySelectorAll('input[type="radio"][data-option-name]'));
      const input = radios.find((radio) => radio.dataset.optionName?.toLowerCase() === name.toLowerCase() && slug(radio.value) === value);
      if (input) return { type: 'radio', node: input };
      const selects = Array.from(picker.querySelectorAll('select'));
      const select = selects.find((element) =>
        Array.from(element.options).some((option) => option.dataset.optionName?.toLowerCase() === name.toLowerCase() && slug(option.value) === value)
      );
      if (!select) return null;
      const option = Array.from(select.options).find((element) => element.dataset.optionName?.toLowerCase() === name.toLowerCase() && slug(element.value) === value);
      return option ? { type: 'select', node: select, option } : null;
    });
    // Never apply only part of a configuration.
    if (targets.some((target) => !target || target.node.disabled || target.node.getAttribute('aria-disabled') === 'true')) return;

    // These changes trigger Horizon's normal variant-fetch and cart workflow.
    targets.forEach((target) => {
      if (target.type === 'radio') {
        if (!target.node.checked) target.node.click();
      } else if (target.node.value !== target.option.value) {
        target.node.value = target.option.value;
        target.node.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', selectConfiguration, { once: true });
  } else {
    selectConfiguration();
  }
})();